<template>
  <div class="resutls-bar h-100 txt-label-primary-2">
    <div class="row f-row spot-row h-100 txt-label-primary-2">
      <div class="col col-3 results-table-headers" v-show="showTitle">
        HISTORY:
      </div>
      <div class="col" v-bind:class="[showTitle ? 'col-9' : 'col-12 ml-1']">
        <div
          class="btn-toolbar"
          role="toolbar"
          aria-label="Toolbar with button groups"
        >
          <div class="btn-group btn-group-toggle btn-block" role="group">
            &nbsp;
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('1M')"
              v-bind:class="[
                pickedDateInterval === '1M' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1M
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('3M')"
              v-bind:class="[
                pickedDateInterval === '3M' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              3M
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('6M')"
              v-bind:class="[
                pickedDateInterval === '6M' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              6M
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('1Y')"
              v-bind:class="[
                pickedDateInterval === '1Y' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1Y
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('2Y')"
              v-bind:class="[
                pickedDateInterval === '2Y' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              2Y
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('5Y')"
              v-bind:class="[
                pickedDateInterval === '5Y' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              5Y
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalyticsHistoricalInterval",
  props: {
    blue: { required: false, type: Boolean, default: false },
    initPickedDateInterval: { required: true },
    showTitle: { required: false, type: Boolean, default: true }
  },
  data() {
    return {
      pickedDateInterval: "1Y"
    };
  },
  watch: {
    initPickedDateInterval() {
      this.pickedDateInterval = this.initPickedDateInterval;
    }
  },
  mounted() {
    this.pickedDateInterval = this.initPickedDateInterval;
  },
  methods: {
    _pickedDateInterval(interval) {
      this.pickedDateInterval = interval;
      this.$emit("eventOnChangeInterval", this.pickedDateInterval);
    }
  }
};
</script>
